import React, { useEffect, useRef, useState } from 'react';

// Mostra a mensagem HTML da exceção numa caixa com altura limitada
// (ver .cs-exception-msg) e sinaliza quando o conteúdo passa do limite,
// já que o texto pode cortar no meio de uma frase sem essa dica.
const ExceptionMessage = ({ mensagem }) => {
  const ref = useRef(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el) setHasOverflow(el.scrollHeight > el.clientHeight + 1);
  }, [mensagem]);

  return (
    <>
      <div className="cs-exception-msg" ref={ref} dangerouslySetInnerHTML={{ __html: mensagem }} />
      {hasOverflow && <small className="cs-exception-msg-more">role para ver mais ▾</small>}
    </>
  );
};

export default ExceptionMessage;
